import { useAuth } from './auth';
import { useEffect } from 'react';

const PING_INTERVAL = 5000; // 5 seconds

const useKeepAlive = () => {
  const { signOut } = useAuth();
  useEffect(() => {
    const STORAGE_KEY = 'lastPingTimestamp';

    const checkLastPing = () => {
      const lastPing = localStorage.getItem(STORAGE_KEY);
      const now = Date.now();

      if (lastPing && now - parseInt(lastPing) > PING_INTERVAL) {
        console.log('Session expired due to inactivity.');
        signOut();
      }
    };

    const sendPing = () => {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    };

    checkLastPing();

    const pingInterval = setInterval(sendPing, PING_INTERVAL);

    return () => {
      clearInterval(pingInterval);
    };
  }, []);
};

export default useKeepAlive;
